import { HttpHelper } from '../helpers/httpHelper';
import { UrlManager } from '../providers/urlManager/urlManager';

const mockWidgetList = [
    {
        widgetName: 'JOB_REQUEST',
        id: '1',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'large',
    },
    {
        widgetName: 'JOB_DESCRIPTION',
        id: '2',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'large',
    },
    {
        widgetName: 'LEAVE_BALANCE',
        id: '3',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'small',
    },
    {
        widgetName: 'TIPS_OF_THE_DAY',
        id: '4',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'small',
    },
    {
        widgetName: 'CANDIDATE_PIPELINE',
        id: '5',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'large',
    },
    {
        widgetName: 'DASHBOARD',
        id: '6',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'small',
    },
    {
        widgetName: 'INTERVIEW_SCHEDULE',
        id: '7',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'large',
    },
    {
        widgetName: 'SHORTLISTED_RESUMES',
        id: '8',
        widgetPreviewImage: 'assets/img/widget/93b1b692-b2e6-11ef-aaf7-185680eae709.png',
        size: 'small',
    },
];

export const contentApi = {
    getTrendingTopics: () => {
        return HttpHelper.fetch(UrlManager.getTrendingTopicsUrl());
    },

    getTipsOfTheDay: () => {
        return HttpHelper.fetch(UrlManager.getTipsOfTheDay());
    },

    reviewRequestJd: data => {
        return HttpHelper.fetch(UrlManager.getReviewRequestJd(), {
            method: 'POST',
            body: data,
        });
    },

    approveJd: data => {
        return HttpHelper.fetch(UrlManager.getApproveJd(), {
            method: 'POST',
            body: data,
        });
    },

    generateJd: data => {
        return HttpHelper.fetch(UrlManager.getGenerateJd(), {
            method: 'POST',
            body: data,
        });
    },

    reviewOfferLetter: data => {
        return HttpHelper.fetch(UrlManager.getReviewOfferLetter(), {
            method: 'POST',
            body: data,
        });
    },

    regenerateOfferLetter: data => {
        return HttpHelper.fetch(UrlManager.getRegenerateOfferLetter(), {
            method: 'POST',
            body: data,
        });
    },

    updateRoleWidgetConfig: data => {
        return HttpHelper.fetch(UrlManager.updateRoleWidgetUrl(), {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },

    getTodoList: empId => {
        if (!empId) throw new Error('EMP ID required');

        return HttpHelper.fetch(UrlManager.getTodoList(), {
            queryParams: {
                emp_id: empId,
            },
            method: 'GET',
        });
    },

    getPoliciesList: location => {
        if (!location) throw new Error('Location required');

        return HttpHelper.fetch(UrlManager.getPoliciesList(), {
            queryParams: {
                location,
            },
            method: 'GET',
        });
    },

    postTodoAction: data => {
        return HttpHelper.fetch(UrlManager.postTodoAction(), {
            method: 'POST',
            body: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    },
    getEventsList: location => {
        if (!location) throw new Error('Location required');

        return HttpHelper.fetch(UrlManager.getEventsList(), {
            queryParams: {
                location,
            },
            method: 'GET',
        });
    },

    getAllWidgets: (mock = true) => {
        if (mock) return mockWidgetList;

        return HttpHelper.fetch(UrlManager.getWidgetsListUrl(), {
            method: 'GET',
        });
    },
};
